import { CurrentSite } from '@snap-types/actions/current-site';
import {
  EmailConfigType,
  FeatureVisibility,
  LeadTimeFormat,
  PartSpecTable,
  QuoteEmailTemplate,
  QuotePdfType,
  SellingUnitOfMeasure,
  SiteCode,
  WonLossStatus,
} from '@snap-types/models/enums';
import { ERPDB } from '@snap-types/models/site/enums';
import { TeamWithConfig } from '@snap-types/models/team';
import { dec } from '@snap-types/types/decimal';

export type SnapSiteConfigState = CurrentSite & {
  currentTeam: TeamWithConfig | null;
};

export const initialState: SnapSiteConfigState = {
  currentTeam: {
    uuid: '',
    teamCode: '',
    teamName: '',
    currentTeamConfig: {
      active: true,
      daysUntilExpectedWin: 2,
      daysUntilExpiration: 30,
      quotePdfType: QuotePdfType.DEFAULT,
      quoteEmailSettings: EmailConfigType.DEFAULT,
      quoteEmailTemplate: QuoteEmailTemplate.DEFAULT,
      quoteIdPrefix: 'AAA',
      alphaEmbedTeam: false,
      uuid: '00000000-0000-4000-8000-000000000001',
    },
  },
  uuid: '',
  code: '',
  name: '',
  erpDB: ERPDB.VISUAL,

  snapSiteConfig: {
    uuid: '00000000-0000-4000-8000-000000000000',

    active: true,
    useConfigurator: false,
    useImportLineItems: false,
    consolidateImportedLineItems: false,
    useQuoteWonLossStatus: false,

    defaultPartRequirementFixedCost: null,
    sellingUnitOfMeasure: SellingUnitOfMeasure.EA,
    decimalPlaces: 2,
    defaultWonLossStatus: WonLossStatus.QUOTED,
    partSpecTable: PartSpecTable.PART_BINARY,
    leadTimeFormat: LeadTimeFormat.NUMBER,
    productionDaysPerWeek: 7,
    transitDaysPerWeek: 7,
    planningDaysPerWeek: 7,
    importFileSizeLimitBytes: 10 * 1024 * 1024, // 10 MB
    sendImportFilesToVisual: true,
    enableUnsupportedCalculationsFlag: false,
    showCostFieldsForFixedPriceStrategies: false,

    partInsightsMaxDaysForInclusion: 1095,
    partInsightsMaxDaysForRecent: 365,
    partInsightsHighWinRate: dec(0.7),
    partInsightsLowWinRate: dec(0.3),
    partInsightsLastOrderGrossMarginThreshold: dec(0.3),
    partInsightsLeadTimeRangeLow: dec(0.1),
    partInsightsLeadTimeRangeHigh: dec(0.3),
    partInsightsLeadTimeMaxDaysForInclusion: 730,
    partInsightsCrossSitePartIdVisible: FeatureVisibility.NONE,
    partInsightsPartHistoryVisible: FeatureVisibility.NONE,
    partInsightsLeadTimeVisible: FeatureVisibility.NONE,
    partInsightsLastOrderGrossMarginVisible: FeatureVisibility.NONE,

    partSearchVisible: FeatureVisibility.NONE,
    partSearchField_commodityCode_enabled: false,
    partSearchField_customerPartId_enabled: true,
    partSearchField_inventory_enabled: true,
    partSearchField_productCode_enabled: false,
    partSearchField_user1_enabled: false,
    partSearchField_user1_name: '',
    partSearchField_user2_enabled: false,
    partSearchField_user2_name: '',
    partSearchField_user3_enabled: false,
    partSearchField_user3_name: '',
    partSearchField_user4_enabled: false,
    partSearchField_user4_name: '',
    partSearchField_user5_enabled: false,
    partSearchField_user5_name: '',
    partSearchField_user6_enabled: false,
    partSearchField_user6_name: '',
    partSearchField_user7_enabled: false,
    partSearchField_user7_name: '',
    partSearchField_user8_enabled: false,
    partSearchField_user8_name: '',
    partSearchField_user9_enabled: false,
    partSearchField_user9_name: '',
    partSearchField_user10_enabled: false,
    partSearchField_user10_name: '',

    duplicateQuoteVisible: FeatureVisibility.NONE,
    searchExistingCustomerPartIdsVisible: FeatureVisibility.NONE,
    alphaVisible: FeatureVisibility.NONE,
    createdByUserUuid: null,
    createdAt: new Date(0),
    updatedAt: new Date(0),
    deletedAt: null,
    priceStrategies: [],
    site: {
      uuid: '00000000-0000-4000-9000-000000000000',
      code: SiteCode.ADF,
      teams: [
        {
          uuid: '00000000-0000-4000-8000-000000000001',
          teamCode: 'DEFAULT',
          teamName: 'Default Team',
          currentTeamConfig: {
            uuid: '00000000-0000-4000-8000-000000000002',
            active: true,
            daysUntilExpectedWin: 2,
            daysUntilExpiration: 30,
            quotePdfType: QuotePdfType.DEFAULT,
            quoteEmailSettings: EmailConfigType.DO_NOT_SEND,
            quoteEmailTemplate: QuoteEmailTemplate.DEFAULT,
            quoteIdPrefix: 'AAA',
            alphaEmbedTeam: false,
          },
        },
      ],
    },
  },
};
